import { EAssetType } from 'constants/enums';

import { TextFieldConfig, UploadFieldConfig } from './RollingOfferFormFields.types';

export const TEXT_FIELDS: TextFieldConfig[] = [
  { label: 'Name', name: 'name', placeholder: 'Name', uniqueFlag: 'isNameUnique' },
  { label: 'External ID', name: 'externalId', placeholder: 'External ID', uniqueFlag: 'isExternalIdUnique' },
  { label: 'Free Offer Text', name: 'collectText', placeholder: 'FREE', defaultValue: '' }
];

export const MAIN_UPLOAD_FIELDS: UploadFieldConfig[] = [
  { title: 'Offer Header Image', fieldName: 'headerImage', forceType: EAssetType.OFFER_HEADER, tooltip: 'Upload an image for the offer header.' },
  { title: 'Arrows Image', fieldName: 'arrowImage', forceType: EAssetType.GENERAL, tooltip: 'Upload a 1:1 ratio image with an arrow pointing to the right.' },
  { title: 'Scroll Arrow Image', fieldName: 'scrollArrowImage', forceType: EAssetType.GENERAL, tooltip: 'Upload a right-pointing arrow image. The system mirrors it for the opposite direction.', disabled: (v) => !v.enableScroll },
  { title: 'Offer Background Image (Vertical)', fieldName: 'backgroundImage', forceType: EAssetType.BG_BUNDLE, tooltip: 'Upload a vertical background image for the rolling offer.' },
  { title: 'Offer Background Image (Horizontal)', fieldName: 'horizontalBackgroundImage', forceType: EAssetType.BG_BUNDLE, tooltip: 'Upload a horizontal background image for the rolling offer.' }
];
